import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summarize: {
		id: 'issue-smart-request-summary-trigger.summarize',
		defaultMessage: 'Summarize',
		description: "Button CTA text allowing the user to summarize an issue's comments",
	},
	tooltip: {
		id: 'issue-smart-request-summary-trigger.tooltip',
		defaultMessage:
			'Get AI to summarize the comments, using the summary and description for context.',
		description:
			'Tooltip displayed when hovering over the Atlassian Intelligence "Summarize" action feature',
	},
	compactTooltip: {
		id: 'issue-smart-request-summary-trigger.compact-tooltip',
		defaultMessage: 'Summarize the comments.',
		description:
			'Tooltip displayed when hovering over the Atlassian Intelligence "Summarize" action feature',
	},
});
